import { Modal } from '@mantine/core';

import { useResponsive } from 'hooks/use-responsive';
import { useAskKlue } from 'pages/dashboard/hooks';
import {
  setAskKlueWizardId,
  useAskKlueSidebarOpen,
  setAskKlueInitialScreen,
} from 'store/views/dashboard';

import { AskKlueContent } from '../ask-klue-content';

function AskKlueModal() {
  const isSidebarOpen = useAskKlueSidebarOpen();
  const { closeModal } = useAskKlue();
  const { maxWidth } = useResponsive();

  function handleClose() {
    closeModal();
    setAskKlueWizardId(undefined);
    setAskKlueInitialScreen(false);
  }

  return (
    <Modal
      opened={true}
      onClose={handleClose}
      withCloseButton={false}
      size={isSidebarOpen ? 1045 : 800}
      fullScreen={maxWidth.small}
      padding={0}
      centered
      zIndex={10} // Same as search bar & klue-ui Layer (z-index: 10); DOM order ensures modal paints above search bar, and klue-ui Layers (portaled later) paint above this modal
      lockScroll={false}
      styles={{
        body: {
          height: '95vh',
          maxHeight: '95vh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        },
        content: {
          backgroundColor: 'transparent',
          height: '95vh',
          maxHeight: '95vh',
          display: 'flex',
          flexDirection: 'column',
        },
        inner: {
          padding: '8px',
          overflow: 'hidden',
        },
      }}
    >
      <AskKlueContent onClose={handleClose} />
    </Modal>
  );
}

export default AskKlueModal;
